import { cva } from 'class-variance-authority'

export const linkVariants = cva('text-main-foreground-accent hover:underline', {
  variants: {
    variant: {
      hyperlink: '',
      back: 'flex items-center gap-1',
    },
  },
  defaultVariants: {
    variant: 'hyperlink',
  },
})
